import { CatSkeleton } from '@blocks-react/components/Skeleton';
import cx from 'classnames';
import styles from '../request-equipment-service-search-loader.module.scss';
import { RequestServiceLoaderMobileProps } from '../types';
import { RequestServiceStepIndicator } from '@cat-ecom/pcc-components';

export const RequestServiceLoaderMobile = ({
  className
}: RequestServiceLoaderMobileProps) => {
  return (
    <div data-testid="requestServiceLoaderMobile">
      <div className="d-flex ">
        <div
          className={cx('mb-4', styles['equipment-info__image-loader-mobile'])}
        >
          <CatSkeleton size="lg" />
        </div>
        <div>
          <div
            className={cx('m-2', styles['equipment-info__name-loader-mobile'])}
          >
            <CatSkeleton size="sm" />
          </div>
          <div
            className={cx(
              'px-2',
              styles['equipment-info__serial-number-loader']
            )}
          >
            <CatSkeleton size="sm" />
          </div>
        </div>
      </div>

      <div className="mb-4 w-100">
        <CatSkeleton size="lg" />
        <CatSkeleton />
        <CatSkeleton size="sm" />
      </div>
      <div className="mt-4 d-flex justify-content-between align-items-baseline">
        <div className={styles['description__heading']}>
          <CatSkeleton size="sm" />
        </div>
        <div className={styles['description__count']}>
          <CatSkeleton size="sm" />
        </div>
      </div>

      <div className="mt-2 mb-4">
        <CatSkeleton size="lg" />
        <CatSkeleton />
        <CatSkeleton size="sm" />
      </div>
      <RequestServiceStepIndicator classname={className} />
      <hr className={styles['bottom-verical-line']} />
    </div>
  );
};
